import { useMutation } from '@tanstack/react-query'
import { deleteWorkShiftCustomField } from 'api/company'
import { useAuthContext } from 'components/auth'
import { MutationOptions } from 'queries/types'
import { useInvalidateWorkShiftCustomFields } from './useWorkShiftCustomFields'

export function useDeleteWorkShiftCustomFieldMutation(
  options: MutationOptions<
    typeof deleteWorkShiftCustomField,
    unknown[],
    number
  > = {}
) {
  const { company } = useAuthContext()
  const { invalidate } = useInvalidateWorkShiftCustomFields()

  return useMutation({
    ...options,
    mutationFn: async (customFieldId: number) => {
      if (!company?.id) {
        throw new Error('Company id not found')
      }
      return deleteWorkShiftCustomField(company.id, customFieldId)
    },
    onSuccess: async (...args) => {
      await invalidate()
      await options.onSuccess?.(...args)
    },
  })
}
